import i18nFactory from '@yandex-int/i18n';
import { TextInput } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    filterSectionsBySearch,
    Section,
    TreeSection
} from '../../service/Experiments/Experiments';
import { Experiment } from '../Experiment/Experiment';

import './ExperimentsSelector.css';
import * as keyset from './ExperimentsSelector.i18n';

const i18n = i18nFactory(keyset);

interface ExperimentsSelectorProps {
    treeOrder: Array<TreeSection>;
    treeData: Record<string, Section>;
    isShowOnlySelected: boolean;
    onChange: (data: { checked: boolean; item: Section }) => void;
    view?: 'classic' | 'default';
}

interface ExperimentsSelectorState {
    search: string;
}

export class ExperimentsSelector extends React.Component<
    ExperimentsSelectorProps,
    ExperimentsSelectorState
> {
    public static defaultProps = {
        view: 'default',
        showOnlySelected: false,
        relations: new Map<number, Array<string>>()
    };

    constructor(props: ExperimentsSelectorProps) {
        super(props);

        this.state = {
            search: ''
        };
    }

    render() {
        const { search } = this.state;
        const { treeOrder, treeData } = this.props;

        const searchedTree = filterSectionsBySearch(
            treeData,
            treeOrder,
            search
        );

        return (
            <div className={Bem.cls('experiments-selector')}>
                <p className={Bem.cls('experiments-selector', 'title')}>
                    {i18n('title')}
                </p>
                <div className={Bem.cls('experiments-selector', 'window')}>
                    <div className={Bem.cls('experiments-selector', 'search')}>
                        <TextInput
                            theme="normal"
                            size="s"
                            view="classic"
                            placeholder={i18n('search-placeholder')}
                            cls={Bem.cls(
                                'experiments-selector',
                                'search-input'
                            )}
                            text={search}
                            onChange={this.onSearchChange}
                            hasClear={true}
                        />
                    </div>
                    <div
                        className={Bem.cls('experiments-selector', 'sections')}
                    >
                        {searchedTree.length > 0
                            ? this.renderSections(searchedTree, treeData)
                            : this.getNotFound()}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Формирование текста, который показывается, если нет отображаемых экспериментов
     * @return {JSX.Element}
     */
    private getNotFound = (): JSX.Element => {
        const { isShowOnlySelected } = this.props;

        return (
            <p className={Bem.cls('experiments-selector', 'not-found')}>
                {isShowOnlySelected ? i18n('not-selected') : i18n('not-found')}
            </p>
        );
    };

    /**
     * Формирование JSX отображаемых экспериментов
     */
    private renderSections = (
        tree: Array<TreeSection>,
        treeData: Record<string, Section>
    ): (JSX.Element | '')[] => {
        const { search } = this.state;
        const { view } = this.props;

        return tree.map(s => {
            const section = treeData[s.id];
            return (
                <div
                    key={section.section_id}
                    className={Bem.cls('experiments-selector', 'section')}
                >
                    <Experiment
                        view={view}
                        checked={section.selected}
                        onChecked={this.onChecked}
                        disabled={section.disabled}
                        tooltip={section.tooltip}
                        search={search}
                        data={section}
                    />
                </div>
            );
        });
    };

    /**
     * Обработчик изменения поля поиска
     * @param {string} value - новое значение
     */
    private onSearchChange = (value: string): void => {
        this.setState({
            search: value
        });
    };

    /**
     * Обработчик выбора эксперимента
     * @param {React.KeyboardEvent<HTMLElement>} e
     * @param {Object} data
     */
    private onChecked = (
        e: React.KeyboardEvent<HTMLElement>,
        data: { item: Section; checked: boolean }
    ): void => {
        const { onChange } = this.props;

        onChange(data);
    };
}
